import { createBatchEventProcessor, createErrorNotifier, createInstance, createPollingProjectConfigManager } from "@optimizely/optimizely-sdk";
import { Logger } from "#lib/logging.js";
import { PUBLIC_OPTIMIZELY_ID } from "$app/env/public";

const eventProcessor = createBatchEventProcessor({
	batchSize: 10,
	flushInterval: 1000,
});

const errorNotifier = createErrorNotifier({
	handleError: err => Logger.error("Optimizely error", { err }),
});

const projectConfigManager = createPollingProjectConfigManager({
	sdkKey: PUBLIC_OPTIMIZELY_ID,
	autoUpdate: true,
	updateInterval: 3 * 60 * 1000, // 3 minutes
});

export const flags = createInstance({
	projectConfigManager,
	eventProcessor,
	errorNotifier,
});
